import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Etude from "./../screens/Etude";
import Experience from "./../screens/Experience";
import Accueil from "../screens/Accueil";
import Etatcivil from "../screens/Etatcivil";
import DomaineCompetence from "../screens/DomaineComptence";
import Competence from "../screens/Competence";
import Fichier from "../screens/Fichier";
import Resume from "../screens/Resume";
import Finaly from "../screens/Finaly";
import OffreEmplois from "../screens/refonte/offre/OffreEmplois";
import Profile from "../screens/refonte/profile/Profile";
import MesDemande from "../screens/refonte/mes_demandes/MesDemande";
import NotFound from "../screens/refonte/NotFound";
import Forbiden from "../screens/refonte/Forbiden";
import PostuleForm from "../screens/refonte/offre/PostuleForm";
import RegistrationPage from "../screens/refonte/auth/RegistrationPage";
import LoginPage from "../screens/refonte/auth/LoginPage";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider, useAuth } from "./AuthContext";
import MesAssociations from "../screens/refonte/mes_association/MesAssociations";
import AssociationInfo from "../screens/refonte/mes_association/AssociationInfo";
import CV from "../screens/refonte/profile/CV";
import CompteActivationPage from "../screens/refonte/auth/CompteActivationPage";
import ResetPassword from "../screens/refonte/auth/ResetPassword";
import ForgotPassword from "../screens/refonte/auth/ForgotPassword";
import DetailDemande from "../screens/refonte/mes_demandes/DetailDemande";
import AppGuid from "../screens/refonte/admin/guide/forms/AppGuid";
import PublicGuid from "../screens/refonte/public_guid/PublicGuid";

const AppRoutes = () => {
  const isAuthenticated = useAuth(); // localStorage.getItem("token") !== null;
  return (
    <>
      {/* <Routes basename="/cv_candidature"> */}
      <AuthProvider>
        {/* <BrowserRouter> */}
        <Routes  basename="">
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/activate-account" element={<CompteActivationPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <OffreEmplois />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offres"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <OffreEmplois />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offres/postule"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <PostuleForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mon-profile"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mon-profile/cv"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mon-profile/association-membre"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mes-demandes"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <MesDemande />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mes-demandes/details"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <DetailDemande />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mes-associations"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <MesAssociations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mes-associations/info"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <AssociationInfo />
              </ProtectedRoute>
            }
          />
          <Route path="/aide" element={<PublicGuid />} />
          <Route path="/403" element={<Forbiden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          {/* </Routes> */}
          {/* <Routes basename="/auth"> */}

          <Route path="/etatcivil" element={<Etatcivil />} />
          <Route path="/etude" element={<Etude />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/competence" element={<DomaineCompetence />} />
          <Route path="/autrecompetence" element={<Competence />} />
          <Route path="/fichier" element={<Fichier />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/finaly" element={<Finaly />} />
          {/* </Routes> */}
        </Routes>
        {/* </BrowserRouter> */}
      </AuthProvider>
    </>
  );
};

export default AppRoutes;
